import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		// these first three state values will come in via the initialization ajax call
		google_client_id: '',
		admin_users: [],
		user_info: {},

		// all projects created/managed by this user
		all_projects: [],

		// the currently-open project, and its index
		project_index: -1,
		project: {},

		// cfdocument; relevant fields are: title, identifier, uri
		cfdocument: {},

		// cfitems; relevant fields for each item are: humanCodingScheme, fullStatement, educationLevel (array), identifier, uri
		cfitems: {},

		// items broken down by type; types are: Cluster, Component, Grade Level, Standard, Strand
		cftypes: {},

		// associations; relevant fields are: associationType, orginNodeURI.identifier, destinationNodeURI.identifier
		// relevant associationTypes are "isChildOf", "exactMatchOf"
		cfassociations: {},

		// tree structure for cfitems
		cftree: {},
		tree_key_hash: [],

		// rows from the imported database table; format for each dbrow is:
		// {order: 23, sid: 'xxx', code: 'xx.x', description: 'xxx', grade_low: 'xx', grade_high: 'xx',
		//    simscores: [{case_guid: 'xxx', descscore: 0.930, codescore: 0.534}] }
		dbrows: [],

		show_saved_indicator: false,
	},
	getters: {
	},
	mutations: {
		set(state, payload) {
			// this.$store.commit('set', ['key', val])
			// update state property 'key' to value 'val'
			if (payload.length == 2) {
				state[payload[0]] = payload[1]
				return
			}

			var o = payload[0]
			var key = payload[1]
			var val = payload[2]

			// this.$store.commit('set', ['obj', 'key', val])
			// update property 'key' of 'o' to value 'val'
			if (typeof(o) == 'string') {
				if (state[o][key] == undefined) Vue.set(state[o], key, val)
				else state[o][key] = val
				return
			}

			// this.$store.commit('set', [obj, 'key', true])
			// this.$store.commit('set', [obj, ['level_1_key', 'level_2_key'], true])
			// this.$store.commit('set', [obj, 'PUSH', 1])	// push 1 onto obj, which must be an array in this case
			// update property of obj, **WHICH MUST BE PART OF STATE!**
			if (typeof(key) == 'string') {
				if (key == 'PUSH') {
					o.push(val)
				} else if (key == 'UNSHIFT') {
					o.unshift(val)
				} else if (o[key] == undefined) {
					Vue.set(o, key, val)
				} else {
					o[key] = val
				}
			} else {
				for (var i = 0; i < key.length-1; ++i) {
					o = o[key[i]]
					if (empty(o)) {
						console.log('ERROR IN STORE.SET', key, val)
						return
					}
				}
				if (o[key[i]] == undefined) Vue.set(o, key[i], val)
				else o[key[i]] = val
			}

			// samples:
			// this.$store.commit('set', [this.exercise, ['temp', 'editing'], true])
			// this.$store.commit('set', [this.qstatus, 'started', true])
		},

		push(state, payload) {
			// this.$store.commit('push', ['key', val])
			// push value 'val' onto property 'key', which must be an array
			if (payload.length == 2 && typeof(payload[0]) == 'string') {
				state[payload[0]].push(payload[1])
				return
			}

			// this.$store.commit('push', [obj, val])
			// push value onto array property of obj, **WHICH MUST BE PART OF STATE!**
			var o = payload[0]
			var val = payload[1]
			o.push(val)
		},

		// this.$store.commit('create_project', project_data[optional])
		create_project(state, project_data) {
			// note that CGRT_Project will create a project_id GUID if one is not sent in
			// use unshift so that we get newest first
			state.all_projects.unshift(new CGRT_Project(project_data))
		},

		// this.$store.commit('delete_project', project_index)
		delete_project(state, index) {
			let ptd = state.all_projects[index]
			// if the project was previously saved, delete from DB (caller should confirm first)
			if (ptd.created_at > 0) {
				let o = {
					user_id: state.user_info.user_id,
					project_id_to_delete: ptd.project_id,
				}
				U.loading_start()
				U.ajax('delete_project', o, result=>{
					U.loading_stop()
					if (result.status != 'ok') {
						alert('Error deleting project!')
						return
					}

					// mark project as deleted in client, mimicing what happens on the server
					ptd.deleted = true
					ptd.file_ids.case_framework = ''
					ptd.file_ids.db_upload = ''
					ptd.file_ids.sim_scores = ''
					ptd.file_ids.status = ''
					console.log('set to deleted')
				});
			} else {
				// if project wasn't saved, just splice out of the all_projects list
				console.log('splice!')
				state.all_projects.splice(index, 1)
			}
		},
	},
	actions: {
		initialize_cgrtool({state, commit, dispatch}, payload) {
			return new Promise((resolve, reject)=>{
				let o = Object({});

				// if payload contains an id_token, send it in to the service
				if (!empty(payload) && !empty(payload.id_token)) {
					o.id_token = payload.id_token
				}

				U.ajax('initialize_app', o, result=>{
					if (result.status != 'ok') {
						reject(result.status)
						return
					}

					console.log('initialized', result)

					// result should always include the google_client_id and admin_users
					commit('set', ['google_client_id', result.google_client_id])
					commit('set', ['admin_users', result.admin_users])

					// if we didn't receive user_info, the user is not already logged in...
					if (empty(result.user_info)) {
						resolve('login')
						return
					}

					// else we should have received user_info, in format specified by U.user_info (utilities.js); save it there
					U.set_user_info(result.user_info)

					// also set user_info in store
					commit('set', ['user_info', result.user_info])

					// receive list of projects and use them to populate project_data
					if (!empty(result.cgrt_projects)) {
						for (let project_data of result.cgrt_projects) {
							commit('create_project', project_data)
						}
					}

					// commit('set', ['cd', result.context_data])
					resolve('projects')
				});
			})
		},

		save_project_data({state, commit, dispatch}, payload) {
			// update existing record with any key/value pairs in payload.pbe ("project being edited")
			let p = state.all_projects[payload.pbe.index]
			for (let key in payload.pbe) {
				if (key == 'index') continue

				// if case_framework_guid has changed, fetch_case_framework should be true
				if (key == 'case_framework_guid' && payload.pbe[key] != p[key]) {
					payload.fetch_case_framework = true
				}

				p[key] = payload.pbe[key]
			}

			if (empty(payload.fetch_case_framework)) payload.fetch_case_framework = false
			if (empty(payload.recalculate_sim_scores)) payload.recalculate_sim_scores = false

			// send through all project_data (not just updated data)
			let o = {
				user_id: state.user_info.user_id,
				project_data: p,
				fetch_case_framework: payload.fetch_case_framework + '',
				recalculate_sim_scores: payload.recalculate_sim_scores + '',
				nonce: U.new_uuid()
			}

			let send_to_server = function(o, state, payload, resolve, reject, pct_complete) {
				U.loading_start(sr('Processing files and/or computing similarities between uploaded database standards and CASE standards<br><br>$1% complete', pct_complete))
				U.ajax('save_project_data', o, result=>{
					U.loading_stop()

					// we may get back project data even if we got an error. replace project data if we got it
					if (!empty(result.project_data)) {
						state.all_projects[payload.pbe.index] = new CGRT_Project(result.project_data)
					}

					if (result.status != 'ok') {
						// if we encountered an error, reject
						reject(result.status)
						return

					}

					// if we didn't finish processing the sim scores, re-call the service, using the same nonce
					if (result.project_data['sim_score_lines_processed'] < result.project_data['line_count_db']) {
						pct_complete = Math.floor(result.project_data['sim_score_lines_processed'] / result.project_data['line_count_db'] * 100)

						// we don't need to include the db_upload or fetch the case framework on subsequent calls
						delete(o.db_upload)
						delete(o.db_filename)
						o.fetch_case_framework = 'false'

						// and we certainly need recalculate_sim_scores to be true in this case (we're definitely still calculating sim scores)
						o.recalculate_sim_scores = 'true'

						// send updated project_data, which will include, i.e., the nonce now set to the value generated for this run
						o.project_data = result.project_data

						// since the nonce is the same as last time, the service will pick up where it left off before
						send_to_server(o, state, payload, resolve, reject, pct_complete)

					} else {
						resolve()
					}
				});
			}

			return new Promise((resolve, reject)=>{
				// if we received an uploaded file...
				if (!empty(payload.db_upload_input)) {
					// process it with a FileReader
					let reader = new FileReader()
					reader.onload = e => {
						// once loaded, send the file contents up to the server
						o.db_upload = e.target.result
						// if we get to here, db_filename should also be included in payload; set that too
						o.db_filename = payload.db_filename
						send_to_server(o, state, payload, resolve, reject, 1)
					}
					// trigger the FileReader to load the text of the file
					reader.readAsText(payload.db_upload_input)

				} else {
					// else no file, so just send to server now
					send_to_server(o, state, payload, resolve, reject, 0)
				}
			})
		},

		load_case_data({state, commit, dispatch}, payload) {
			return new Promise((resolve, reject)=>{
				let o = {
					user_id: state.user_info.user_id,
					project_id: state.project.project_id,
					file_type: 'case_framework',
				}
				U.ajax('retrieve_file', o, result=>{
					if (result.status != 'ok') {
						console.log('Error loading DB data')
						reject(result.status)
						return
					}

					let data = JSON.parse(result.file_content)

					// PROCESS THE CASE DATA

					// stash the CFDocument, after adding tree_keys
					data.CFDocument.tree_keys = []
					data.CFDocument.tree_nodes = []
					commit('set', ['cfdocument', data.CFDocument])

					// uncomment this if we need access to cfassociations outside of this fn
					// commit('set', ['cfassociations', data.CFAssociations])

					// put the CFItems into a hash, to make it easy to pull the data out
					// also create a structure to represent items by type
					let items = {}
					let types = {}
					for (let item of data.CFItems) {
						// lowercase versions for filtering purposes
						if (!empty(item.fullStatement)) item.fullStatement_lc = item.fullStatement.toLowerCase()
						if (!empty(item.humanCodingScheme)) item.humanCodingScheme_lc = item.humanCodingScheme.toLowerCase()

						// some frameworks (e.g. Texas) have educationLevel coded as a string, whereas we expect an array. fix if necessary
						if (empty(item.educationLevel)) {
							item.educationLevel = []

						} else if (typeof(item.educationLevel) == 'string') {
							item.educationLevel = item.educationLevel.split(/\s*,\s/)
						}

						// add tree_keys and tree_nodes array for use below
						item.tree_keys = []
						item.tree_nodes = []

						items[item.identifier] = item

						// and to types hash
						if (empty(types[item.CFItemType])) types[item.CFItemType] = []
						types[item.CFItemType].push(item)
					}

					let copy_count = 0
					for (let g in items) {
						let item = items[g]
						// look for exactMatchOf associations
						for (let a of data.CFAssociations) {
							// if this node is the origin of an exact match, note that this is a copy of the destination node
							if (a.associationType == 'exactMatchOf' && a.originNodeURI.identifier == item.identifier) {
								// but we only care about within-framework matches
								if (empty(items[a.destinationNodeURI.identifier])) continue

								++copy_count
								item.is_copy_of = a.destinationNodeURI.identifier
								// console.log(sr('$1 is copy of $2', item.identifier, item.is_copy_of))
							}
						}
					}
					console.log(copy_count + ' copies found')

					commit('set', ['cfitems', items])
					commit('set', ['cftypes', types])

					// construct tree structure
					let tree_key = 0
					let tree_key_hash = []
					let build_node = function(cfitem, parent_node, sequence) {
						let node = {
							tree_key: tree_key,
							cfitem: cfitem,
							parent_node: parent_node,
							children: [],
							sequence: sequence,
						}

						// store tree_key and tree_node in cfitem, store node in tree_key_hash, then increment tree_key for the next one
						cfitem.tree_nodes.push(node)
						cfitem.tree_keys.push(tree_key)
						tree_key_hash[tree_key] = node
						++tree_key

						// recursively process children
						for (let a of data.CFAssociations) {
							if (a.associationType == 'isChildOf' && a.destinationNodeURI.identifier == node.cfitem.identifier) {
								node.children.push(build_node(items[a.originNodeURI.identifier], node, a.sequenceNumber))
							}
						}

						// order children by sequence. Note that the sequenceNumbers are in the *associations*, and that not all nodes have sequenceNumbers
						node.children.sort((a,b)=>{
							a = a.sequence
							b = b.sequence
							if (!empty(a) && !empty(b)) return a - b
							if (!empty(a) && empty(b)) return -1
							if (!empty(b) && empty(a)) return 1
							return 0
						})

						return node
					}
					commit('set', ['cftree', build_node(data.CFDocument)])
					commit('set', ['tree_key_hash', tree_key_hash])

					resolve()
				});
			})
		},

		load_dbrows({state, commit, dispatch}, payload) {
			return new Promise((resolve, reject)=>{
				let o = {
					user_id: state.user_info.user_id,
					file_type: 'db_upload',
				}

				// if payload is empty, use state.project; otherwise payload should be the project_id
				if (empty(payload)) {
					o.project_id = state.project.project_id
				} else {
					o.project_id = payload
				}
				U.ajax('retrieve_file', o, result=>{
					if (result.status != 'ok') {
						console.log('Error loading DB data')
						reject(result.status)
						return
					}

					let data = result.file_content

					// PROCESS THE DB ROWS
					let lines = data.split('\n')

					if (state.project.db_delimiter == 'tab') {
						lines = TSV.parse(data)
					} else {
						lines = CSV.parse(data)
					}

					// get header line
					let header = lines.shift()

					let dbrows = []
					let order = 0
					for (let line of lines) {
						if (line.length == 0) continue

						// start creating dbrow
						let dbrow = {
							order: order,
							status: 'unmatched',
							selected_case_item: {},
							top_simscore: {},
							simscores: [],
							show_status: 'cropped'	// 'cropped', 'one_full', or 'all_full'
						}

						// add values from line based on headers
						let header_errors = []
						for (let i = 0; i < header.length; ++i) {
							let column = header[i]

							if (column == 'STANDARD_ID') {
								dbrow.sid = $.trim(line[i])
							} else if (column == 'TEXT') {
								dbrow.description = $.trim(line[i])
							} else if (column == 'CODE') {
								dbrow.code = $.trim(line[i])
							} else if (column == 'GRADE_LOW') {
								dbrow.grade_low = $.trim(line[i])
							} else if (column == 'GRADE_HIGH') {
								dbrow.grade_high = $.trim(line[i])
							} else if (column == 'ALIGNABLE') {
								dbrow.is_alignable = ($.trim(line[i]) == '1')
							} else if (column == 'LEAF') {
								dbrow.is_leaf = ($.trim(line[i]) == '1')
							} else {
								header_errors.push(column)
							}
						}
						// note that $.trim(null) === ''

						// if we got any illegal errors, alert and quit
						// note that we *shouldn't* ever get header_errors, because the header should be checked when the file is initially uploaded.
						if (header_errors.length > 0) {
							reject('Illegal column name(s) in database upload file: ' + header_errors.join(', ') + '<br><br>Edit your DB Rows file and ensure that the first line of the document includes some combination of the following column names (with all column names in all upper-case, as shown here):<br><br>STANDARD_ID<br>TEXT<br>CODE<br>GRADE_LOW<br>GRADE_HIGH<br>ALIGNABLE<br>LEAF<br><br>Then re-upload the file and try again. Note that columns can appear in any order.')
							return
						}

						// lowercase versions for filtering purposes
						if (!empty(dbrow.description)) dbrow.description_lc = dbrow.description.toLowerCase()
						if (!empty(dbrow.code)) dbrow.code_lc = dbrow.code.toLowerCase()

						// push onto dbrows
						dbrows.push(dbrow)
						++order
					}

					commit('set', ['dbrows', dbrows])

					resolve()
				});
			})
		},

		load_simscores({state, commit, dispatch}, payload) {
			return new Promise((resolve, reject)=>{
				let o = {
					user_id: state.user_info.user_id,
					project_id: state.project.project_id,
					file_type: 'sim_scores',
				}
				U.ajax('retrieve_file', o, result=>{
					if (result.status != 'ok') {
						console.log('Error loading similarity scores')
						reject(result.status)
						return
					}

					let data = result.file_content

					// PROCESS THE SIM_SCORES

					// split incoming lines into an array; skip header row
					let lines = data.split('\n')
					lines.shift()

					let last_sid = null
					let current_sid_index = -1
					let dbrow
					for (let line of lines) {
						if (empty(line)) continue

						let vals = line.split(',')

						if (vals.length == 1) {
							reject('Invalid value found in similarity score file:<br><br>' + line)
							return
						}
						// currently column 0 contains the line number
						let simscore = {
							case_guid: vals[2],
							descscore_raw: vals[3]*1,
							codescore_raw: vals[4]*1,
							descscore: (Math.floor(vals[3]*1000)/1000).toFixed(3),	// round down to 3 decimal places
							codescore: (Math.floor(vals[4]*1000)/1000).toFixed(3),	// round down to 3 decimal places
						}

						// if this is a new sid, look for corresponding dbrow (it should be there)
						if (vals[1] != last_sid) {
							++current_sid_index
							if (state.dbrows[current_sid_index].sid == vals[1]) {
								dbrow = state.dbrows[current_sid_index]
							} else {
								dbrow = state.dbrows.find(o=>o.sid == vals[1])
								console.log(sr('had to find it: $1, $2', state.dbrows[current_sid_index].sid, vals[1]))
							}

							if (empty(dbrow)) {
								console.log('couldn’t find dbrow for sid ' + vals[1])
								continue
							}

							// set selected_case_item and set top_simscore first row
							if (!empty(state.cfitems[simscore.case_guid])) {
								dbrow.selected_case_item = state.cfitems[simscore.case_guid]
								dbrow.top_simscore = simscore
							} else {
								console.log('couldn’t find selected_case_item for sid ' + vals[1])
							}
						}
						last_sid = dbrow.sid

						// add simscore for this line
						dbrow.simscores.push(simscore)
					}

					resolve()
				});
			})
		},

		load_status({state, commit, dispatch}, payload) {
			return new Promise((resolve, reject)=>{
				// if the project doesn't have a blob_id for the status file, it means we haven't saved one yet, so just return
				if (empty(state.project.file_ids.status)) {
					resolve()
					return
				}

				let o = {
					user_id: state.user_info.user_id,
					project_id: state.project.project_id,
					file_type: 'status',
				}
				U.ajax('retrieve_file', o, result=>{
					if (result.status != 'ok') {
						console.log('Error loading current match status')
						reject(result.status)
						return
					}

					if (!empty(result.file_content)) {
						console.log('restoring match status...')
						let hash = JSON.parse(result.file_content)
						for (let sid in hash) {
							let dbrow = state.dbrows.find(o=>o.sid == sid)
							if (empty(dbrow)) {
								// if we didn't find this sid, we skip this line in the status file
								console.log('- couldn’t find dbrow for sid ' + sid)
								continue
							}
							// for parked or nomatch, we just save status
							if (hash[sid] == 'parked' || hash[sid] == 'nomatch') {
								dbrow.status = hash[sid]
							// otherwise it's matched; save status and selected_case_item
							} else {
								dbrow.status = 'matched'
								dbrow.selected_case_item = state.cfitems[hash[sid]]

								// if we didn't find the selected_case_item, skip this line in the status file by clearing the status
								if (empty(dbrow.selected_case_item)) {
									console.log('- couldn’t find case item for sid ' + sid)
									dbrow.selected_case_item = {}
									dbrow.status = 'unmatched'
								}
							}
						}
					}
					resolve()
				});
			})
		},

		// this.$store.dispatch('save_status')
		save_status({state, commit, dispatch}) {
			return new Promise((resolve, reject)=>{
				// establish the debounce fn if necessary
				if (empty(state.save_status_debounced)) {
					state.save_status_debounced = U.debounce(function(state, resolve, reject) {
						// construct hash with status for each dbrow; also compute summary stats along the way
						state.project.status_summary = {
							db_row_count: 0,
							unmatched: 0,
							matched: 0,
							parked: 0,
							nomatch: 0,
						}
						let hash = {}
						for (let dbrow of state.dbrows) {
							++state.project.status_summary.db_row_count
							// for matched items, store the guid
							if (dbrow.status == 'matched') {
								// shouldn't selected_case_item always be true? if not, leave it as unmatched and console.log an error
								if (!empty(dbrow.selected_case_item)) {
									hash[dbrow.sid] = dbrow.selected_case_item.identifier
									++state.project.status_summary.matched
								} else {
									++state.project.status_summary.unmatched
									console.log('found dbrow marked as matched but with no selected_case_item', dbrow)
								}

							// for unmatched items, don't store anything; else store the status
							} else if (dbrow.status != 'unmatched') {
								hash[dbrow.sid] = dbrow.status
								++state.project.status_summary[dbrow.status]
							} else {
								++state.project.status_summary.unmatched
							}
						}

						// save status to file on server; we also send the full project data structure, which includes summary data
						let o = {
							user_id: state.user_info.user_id,
							project_data: state.project,
							file_contents: JSON.stringify(hash)
						}

						U.ajax('save_status_file', o, result=>{
							U.loading_stop()
							if (result.status != 'ok') {
								alert('Error saving project status file!')
								reject()
								return
							}
							// replace project data with returned project_data
							state.all_projects[state.project_index] = new CGRT_Project(result.project_data)
							state.project = state.all_projects[state.project_index]

							state.show_saved_indicator = true
							setTimeout(()=>{ state.show_saved_indicator = false }, 2000)
							resolve()
						});
					}, 1000)
				}

				// call the debounce fn
				state.save_status_debounced(state, resolve, reject)
			})
		},

		// this.$store.dispatch('sign_out')
		sign_out({state, commit, dispatch}) {
			return new Promise((resolve, reject)=>{
				U.ajax('sign_out', {}, result=>{
					if (result.status != 'ok') {
						alert('Error signing out!')
						reject()
						return
					}

					// on success, reload the page, which should show the google login button
					document.location.reload()
				});
			})
		},
	}
})
